// extracted by mini-css-extract-plugin
export default {"depositTransfer":"ARSF9","depositTransfer__button":"BH33W"};